module.exports = __webpack_public_path__ + "img/img_side_lace.d79047e6.png";